
/*
	(v1.13)
	
	Valida un string y devuelve "" si está bien, o el mensaje de error en caso de tener algún error.
	
	Ejemplos:

		validador("#123", "12345678");			// ""
		validador("#123_", "1234 5678");		// ""
		validador("#abc", "pepe");				// ""
		validador("#abc_", "pepe pepe");		// ""
		validador("#ab123", "123pepe");			// ""
		validador("#ab123_", "123 pepe");		// ""

		validador("dni", "12345678Z"); 		// ""
		validador("dni", "1234"); 			// El DNI tiene que tener como mínimo X caracteres y tenía X
		validador("dni", "1234567890"); 	// El DNI tiene que tener como máximo X caracteres y tenía X
		validador("dni", "pepe1234pablo"); 	// El DNI debe seguir una de las siguiente estructuras...
		validador("dni", "X1234567A"); 		// La letra final del DNI es incorrecta, debería ser L
		validador("dni", "12345678A"); 		// La letra final del DNI es incorrecta, debería ser Z

		validador("iban", "ES6000491500051234567892");		// ""
		validador("iban", "ES60004915000512345678921"); 	// El IBAN tiene que tener como mínimo X caracteres y tenía X
		validador("iban", "ES600049150005123456789");	 	// El IBAN tiene que tener como máximo X caracteres y tenía X
		validador("iban", "ZZpepe491500051234569999");	 	// El IBAN debe seguir la siguiente estructura...
		validador("iban", "ES6000491500051234569999");	 	// El IBAN no es válido.

		validador("telefono", "612345678"); 	// ""
		validador("telefono", "12345678"); 		// El teléfono tiene que tener como mínimo X caracteres y tenía X
		validador("telefono", "1234567890");	// El teléfono tiene que tener como máximo X caracteres y tenía X
		validador("telefono", "pepe12356"); 	// El teléfono sólo puede contener números
		validador("telefono", "512345678"); 	// El teléfono debe ser español
		validador("telefono", "901123456"); 	// El teléfono no es válido

		validador("email", "email@asd.com");	// ""
		validador("email", "emailasd.com");		// "El email debe seguir la siguiente estructura..."

		validador("contraseña", "Asdfghjk1");		// ""
		validador("contraseña", "asd");				// "Tiene que tener como mínimo X caracteres y tenía X"
		validador("contraseña", "asdfghjk");		// "Debe tener al menos una letra mayúscula"
		validador("contraseña", "Asdfghjk");		// "Debe tener al menos un número"

	.

*/


const specialCharacters = ",.#·:$%&()?¿!¡@|+_\\-ºª/";
const spanishCharacters = "áéíóúàèìòùäëïöü'´çñ";



const compruebaLongitud = (textoParaValidar, required, minLength, maxLength) => {

	let length = textoParaValidar.length;


	if (required && minLength && length < minLength) {
		return `Debe tener como mínimo ${minLength} caracteres y tiene ${length}.`;
	};
	if (required && maxLength && length > maxLength) {
		return `Debe tener como máximo ${maxLength} caracteres y tiene ${length}.`;
	};


	return ""; // todo guay

};



/**
	* Valida un string.
	* 
	* 	import validador from "./utils/validador";
	* ___ 
	* 
	* @param {string} tipoValidacion Qué tipo de validación se va a realizar.
	* 
	* - "dni", "cif", "iban", "telefono", "email", "contraseña", "cp", "cups" 
	* - "#123"
	* - "#123_"
	* - "#abc"
	* - "#abc!"
	* - "#abc_"
	* - "#abc!_"
	* - "#abc123"
	* - "#abc123_"
	* - "#abc123!"
	* - "#abc123!_"
	* 
	* @param {string} textoParaValidar - Texto que se va a validar.
	* @param {bool}  [required=false] - ¿Puede estar vacío? Si es false, no se comprobará la longitud.
	* @param {number} [minLength=0] - Longitud mínima. Usar 0 para no comprobar.
	* @param {number} [maxLength=0] - Longitud máxima. Usar 0 para no comprobar.
	* @param {string} [flags=""] - "g" (global), "i" (ignore case) o "m" (multiline).
	* 
	* ___
	* @returns {string} "" si está todo correcto o el error si hubiese.
*/

module.exports = (tipoValidacion = "", textoParaValidar = "", required = false, minLength = 0, maxLength = 0, flags = "") => {

	if (tipoValidacion === "") return "ERR validador: tipoValidacion undef.";

	if (typeof textoParaValidar === "number") textoParaValidar = textoParaValidar.toString();
	if (typeof textoParaValidar !== "string") return "ERR validador: Tipo no válido";


	textoParaValidar = textoParaValidar.trim();
	if (required && textoParaValidar === "") return "No puede estar vacío.";
	if (!required && textoParaValidar === "") return ""; // Como no es requerido y está vacío, no hago más comprobaciones


	let mensajeError = ""; // si todo va bien, se quedará así



	// Si el tipo de validacion es #algo, compruebo longitud
	if (tipoValidacion.slice(0, 1) === "#") {
		let errorLongitud = compruebaLongitud(textoParaValidar, required, minLength, maxLength);
		if (errorLongitud) return errorLongitud;
	};



	switch (tipoValidacion) {

		case "#123": {
			let regex = new RegExp(/^[0-9]*$/, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener números.";

			break;
		};

		case "#123_": {
			let regex = new RegExp(/^[0-9\s ]*$/, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener números y espacios.";

			break;
		};

		case "#abc": {
			let regex = new RegExp(`^[a-z${spanishCharacters}]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener letras.";

			break;
		};
		case "#abc!": {
			let regex = new RegExp(`^[a-z${spanishCharacters}${specialCharacters}]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return `Sólo puede contener letras y caracteres especiales como ${specialCharacters}.`;

			break;
		};
		case "#abc_": {
			let regex = new RegExp(`^[a-z${spanishCharacters} ]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener letras y espacios.";

			break;
		};
		case "#abc!_": {
			let regex = new RegExp(`^[a-z${spanishCharacters}${specialCharacters}]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return `Sólo puede contener letras, espacios y caracteres especiales como ${specialCharacters}.`;

			break;
		};

		case "#abc123": {
			let regex = new RegExp(`^[a-z${spanishCharacters}0-9]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener letras y números.";

			break;
		};
		case "#abc123_": {
			let regex = new RegExp(`^[a-z${spanishCharacters}0-9]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener letras, números y espacios.";

			break;
		};
		case "#abc123!": {
			let regex = new RegExp(`^[a-z${spanishCharacters}0-9${specialCharacters}]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener letras, números y espacios.";

			break;
		};
		case "#abc123!_": {
			let regex = new RegExp(`^[a-z${spanishCharacters}0-9${specialCharacters}\n ]*$`, flags);
			let correcto = regex.test(textoParaValidar);
			if (!correcto) return "Sólo puede contener letras, números, espacios y saltos de línea.";

			break;
		};



		case "telefono": {

			// Fuerzo parámetros
			minLength = 9;
			maxLength = 9;



			// *******************
			// Compruebo longitud
			// *******************

			let errorLongitud = compruebaLongitud(textoParaValidar, required, minLength, maxLength);
			if (errorLongitud) return errorLongitud;



			// *******************
			// Compruebo estructura
			// *******************

			let regex = new RegExp(/^[0-9]*$/, "");
			let correcto1 = regex.test(textoParaValidar);
			if (!correcto1) return "Sólo puede contener números.";

			let correcto2 = ["6", "7"].includes(textoParaValidar.slice(0, 1));
			if (!correcto2) return "Tiene que empezar por 6 o 7.";

			//let contieneNumerosMalos = ["901", "902", "905", "803", "806", "807"].includes(textoParaValidar.slice(0, 3));
			//if (contieneNumerosMalos) return "El teléfono no es válido.";


			break
		};

		case "movilTelefono": {

			// Fuerzo parámetros
			minLength = 9;
			maxLength = 9;



			// *******************
			// Compruebo longitud
			// *******************

			console.log('textoParaValidar', textoParaValidar);

			let errorLongitud = compruebaLongitud(textoParaValidar, required, minLength, maxLength);
			if (errorLongitud) return errorLongitud;
			// if (textoParaValidar === '') {
			// 	return 'No puede estar vacío';
			// }



			// *******************
			// Compruebo estructura
			// *******************

			let regex = new RegExp(/^[0-9]*$/, "");
			let correcto1 = regex.test(textoParaValidar);
			if (!correcto1) return "Sólo puede contener números.";

			let correcto2 = ["6", "7", "9"].includes(textoParaValidar.slice(0, 1));
			if (!correcto2) return "Tiene que empezar por 6, 7 o 9.";

			let contieneNumerosMalos = ["900", "901", "902", "905", "803", "806", "807"].includes(textoParaValidar.slice(0, 3));
			if (contieneNumerosMalos) return "El teléfono no es válido.";


			break
		};



		case "email": {



			// Fuerzo parámetros
			minLength = 1;



			// *******************
			// Compruebo longitud
			// *******************

			let errorLongitud = compruebaLongitud(textoParaValidar, required, minLength, maxLength);
			if (errorLongitud) return errorLongitud;



			// *******************
			// Compruebo estructura
			// *******************

			// let regex = new RegExp(/^[^_a-zA-Z0-9\s]/, "g");
			// let empiezaMal = regex.test(textoParaValidar);
			// if (empiezaMal) return "Email inválido";

			// let strPreArroba = textoParaValidar.split("@")[0];
			// regex = new RegExp(/\(\)<>@,;:"\[\]ç%&áéíóúàèìòùäëÏöüâêîôû\s/gim);
			// let tieneCaracteres = regex.test(strPreArroba);
			// if (tieneCaracteres) return "Email inválido";

			// regex = new RegExp(/^[\w\.\-\+]+@\w+(\.[\w\-]{2,16})+$/, "g");
			// let correcto = regex.test(textoParaValidar);

			// if (!correcto) return "Debe seguir la siguiente estructura: direccion@email.es";


			break
		};


		default: break;

	};



	return mensajeError;

};


